import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HierarchyDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.scss']
})
export class HierarchyComponent implements OnChanges {

  hierarchyForm: FormGroup;
  hierarchyFormArray: FormGroup;
  control = new FormControl();
  @Input() hierarchys: HierarchyDto[];
  @Input() routeAnimationsElements: any;
  @Output() hierarchy = new EventEmitter<HierarchyDto[]>();
  @Output() deleteHierarchyEvent = new EventEmitter<any>();

  selectedHierarchy: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createHierarchyForm();
  }

  createHierarchyForm() {
    this.hierarchyForm = this.fb.group({
      HierarchyName: ['', Validators.required],
      Abbreviation: ['', Validators.required],
      Description: ['', Validators.required],
      id: null,
    });
    this.hierarchyFormArray = this.fb.group({
      Hierarchys: this.fb.array([]),
    });
    this.setHierarchy();
  }

  // method to display hierarchys
  setHierarchy() {
    const control = this.hierarchyFormArray.controls.Hierarchys as FormArray;
    this.hierarchys.forEach((e) => {
      control.push(
        this.fb.group({
          HierarchyName: e.HierarchyName,
          Abbreviation: e.Abbreviation,
          Description: e.Description,
          id: e.id,
        })
      );
    });
  }

  // method to add Hierarchy
  addHierarchy(value: HierarchyDto) {
    const control = this.hierarchyFormArray.controls.Hierarchys as FormArray;
    control.insert(
      0,
      this.fb.group({
        HierarchyName: value.HierarchyName,
        Abbreviation: value.Abbreviation,
        Description: value.Description,
        id: null,
      })
    );
  }

  selectHierarchy(value) {}

  // method to delete hierarchy from arrary list
  deleteHierarchy(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.hierarchyFormArray.controls.Hierarchys as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.hierarchys.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.hierarchys[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: HierarchyDto) {
    if (this.hierarchyForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.hierarchyFormArray
        .get('Hierarchys')
        ['controls'][this.selectedIndex].patchValue({
          HierarchyName: formValue.HierarchyName,
        });
    } else {
      this.addHierarchy(formValue);
    }
    this.selectedIndex = null;
    this.hierarchyForm.reset();
  }

  onEdit(index, value: HierarchyDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.hierarchyForm.patchValue({ HierarchyName: value.HierarchyName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.hierarchyForm.reset();
  }

  onSubmit(formValue: HierarchyDto[]) {
    this.hierarchy.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteHierarchyEvent.emit(this.filteredDelete);
    }
  }
}